import React from "react";
import { useToast } from "hooks";
import { FormattedMessage } from "react-intl";

export default function usePdfDownload() {
  const { toast } = useToast();

  const downloadPdf = async (url) => {
    try {
      const res = await fetch(url);

      if (!res.ok) {
        const data = await res.json();
        toast.error(data.error || <FormattedMessage id="usePdfDownload.Error" />);
        return;
      }

      // It's a PDF, create blob for download
      const blob = await res.blob();
      const blobUrl = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = blobUrl;

      // Try extracting filename from headers
      const disposition = res.headers.get("Content-Disposition");
      const match = disposition && disposition.match(/filename="?([^"]+)"?/);
      link.download = match ? decodeURIComponent(match[1]) : "download.pdf";

      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(blobUrl);
    } catch (err) {
      toast.error(<FormattedMessage id="usePdfDownload.Error" />);
    }
  };

  return { downloadPdf };
}
